import Calendar from "../../views/apps/calendar/Calendar.vue";

import layouts from "../../layout";

export default {
  path: "/calendar",
  name: "calendar",
  component: Calendar,
  meta: {
    auth: true,
    searchable: true,
    title: "Calendar",
    layout: layouts.navLeft,
    tags: ["calendar"]
  }
};
